import React from 'react'
import Grid, { FlexCell } from '@integec/grid-tools'
import { strCol } from '@integec/grid-tools/lib/cols'
import flexGridRenderer, { Cell } from '@integec/grid-tools/lib/flexRenderer'
import { formatData, extractData } from '@integec/grid-tools/lib//utils'
// import { getApiTargetInfo } from 'core'
// import PiaTableInfoAntd from './PiaTableInfoAntd'
// import { Button, message } from 'antd'
// import { savePerfData } from 'api/pgads'
// import * as freeEditEngine from '@integec/grid-tools/lib/editEngine'
// import { applyEdits } from '@integec/grid-tools/lib/editEngine'
// import { connect } from 'react-redux'
import { BasicColHeader } from '@integec/grid-tools/lib/Components'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
// import { SpinContext, ErrorContext } from 'context'
const headers = screenSize => [
  strCol({
    ident: 'rowHeader1',
    display: 'Row Header 1',
    editable: false,
  }),
  strCol({
    ident: 'content1',
    display: 'Content 1',
    idx: 1,
    width: 70,
  }),
  strCol({
    ident: 'rowHeader2',
    display: 'Row Header 2',
  }),
  strCol({
    ident: 'content2',
    display: 'Content 2',
    idx: 2,
    width: 70,
  }),
  strCol({
    ident: 'rowHeader3',
    display: 'Row Header 3',
  }),
  strCol({
    ident: 'content3',
    display: 'Content 3',
    idx: 3,
    width: 70,
  }),
  strCol({
    ident: 'rowHeader4',
    display: 'Row Header 4',
  }),
  strCol({
    ident: 'content4',
    display: 'Content 4',
    idx: 4,
    width: 70,
  }),
  strCol({
    ident: 'rowHeader5',
    display: 'Row Header 5',
  }),
  strCol({
    ident: 'content5',
    display: 'Content 5',
    idx: 5,
    width: parseInt(screenSize.width) - 500 - 70 * 4,
    // width: 100,
    alignment: 'left',
  }),
]

const defaultColHeaderRendererHid = () => ''

const renderFlex = (screenSize, editable) =>
  flexGridRenderer({
    headerRowHeight: 0,
    // width: screenSize.width ? screenSize.width : undefined,
    width: parseInt(screenSize.width) - 150 - 150,
    // containerWidth: parseInt(screenSize.width) + 'px',
    height: screenSize.height,
    autoFixColByKey: false,
    // fixedColCount: 1,
    // fixedScrollHeightAdjustment: 1,
    cellRenderer: defaultCellRenderer(editable),
    colHeaderRenderer: defaultColHeaderRendererHid,
    borderSize: 10,
    rowHeight: 18,
  })

export const defaultCellRenderer = hasPermission => ({
  rowIndex,
  // columnIndex,
  header,
  width,
  // height,
  data,
  // render,
  // altIndexes,
  // altBgColor,
  // display,
  ...rest
}) => {
  const value = extractData({ header, rowData: data[rowIndex] })
  const display = formatData({ header, value, rowData: data[rowIndex] })

  const isEditableCell = isEditable(
    data,
    hasPermission
  )({ header, rowData: data[rowIndex] })
  if (!isEditableCell)
    return (
      <FlexCell
        // width={header.ident.toLowerCase().includes('con') ? '30px': width}
        width={width}
        fontSize="small"
        style={{
          // fontSize: 'small',
          // height: '15px',
          backgroundColor: 'rgb(211,211,211,0.4)',
        }}
      >
        {data[rowIndex][header.ident]}
      </FlexCell>
    )

  return (
    <Cell
      {...rest}
      title={`${value}`}
      // width={header.ident.toLowerCase().includes('con') ? '30px': width}
      width={width}
      fontSize="small"
      style={
        {
          // height: '15px',
          // fontSize: 'small',
        }
      }
    >
      {display}
    </Cell>
  )

  // return <PureCell title={value + ''} width={width} height={height} display={display} {...rest} />
}

export const ColHeader = BasicColHeader.extend`
  flex: 0 0 ${props => props.width}px;
  width: ${props => props.width}px;
  max-width: ${props => props.width}px;
`

const readOnlyCols = [
  'rowHeader1',
  'rowHeader2',
  'rowHeader3',
  'rowHeader4',
  'rowHeader5',
]
const isEditable = (data, editable) => ({ header, rowData }) => {
  const t = !readOnlyCols.includes(header.ident)
  if (editable === false) return false
  if (t === false) return false

  const status = rowData.status || 'R'
  if (status === 'R') return false
  if (status === 'W') return true

  const idx = header.idx - 1

  const rw = status.substring(idx, idx + 1)
  if (rw === 'W') return true

  return false
}

class PerfDisplayGrid extends React.Component {
  constructor(props) {
    super(props)

    // this.saveData = this.saveData.bind(this)
    // this.setDataErrors = this.setDataErrors.bind(this)
    // this.setShowEditDialog = this.setShowEditDialog.bind(this)
    this.editable = hasAccesPermits({
      authGodMode: props.envConfig.authGodMode,
      actionPermits: props.actionPermits,
      eventActions: [ScreenPermissions.MONTHLY_OPERATION_SAVE_PERF_DATA],
      matchAny: true,
    })
  }

  // setDataErrors(dataErrors) {
  //   this.setState({ dataErrors })
  // }

  // setShowEditDialog() {
  //   this.setDataErrors()
  // }

  // setEditInfo(editInfo) {
  //   this.setState(_ => ({ editInfo, showAdd: false }))
  // }

  // saveData() {
  //   const {
  //     year,
  //     month,
  //     utility,
  //     unit,
  //     shortName,
  //     apiTargetInfo,
  //     data,
  //     setError,
  //     setSpinning,
  //   } = this.props
  //   const editInfo = this.state.editInfo
  //   const data99 = { data, editInfo }
  //   const editedData = applyEdits(data99)
  //   setSpinning(true)
  //   savePerfData(
  //     apiTargetInfo,
  //     editedData,
  //     year,
  //     month,
  //     utility,
  //     unit.substring(utility.length),
  //     shortName
  //   )().fork(setError, dt => {
  //     setSpinning(false)
  //     // if (dt.filter(d => d.severity === '1' || d.severity === 1).length > 0) {
  //     if (dt.length > 0) {
  //       this.setDataErrors(dt)
  //     } else {
  //       message.success('Data saved Successfully.')
  //       this.props.retrieveData && this.props.retrieveData()
  //     }
  //   })
  // }

  render() {
    if (this.props.data === undefined || this.props.data.length === 0)
      return <div />
    return (
      <>
        {/* <div style={{ display: 'grid', gridTemplateColumns: 'min-content auto' }}> */}

        <div style={{ display: 'grid', gridTemplateColumns: '100px auto' }}>
          <div />
          <div
            ref={this.props.cref}
            style={{
              width: this.props.screenSize.width + 'px',

              // marginLeft: '100px',
              // marginRight: '100px',
              display: 'flex',
              // gridRowEnd: 'span 2',
              // justifyContent: 'space-between',
              overflowX: 'hidden',
              overflowY: 'hidden',
              maxWidth: this.props.screenSize.maxWidth + 'px',
            }}
          >
            <Grid
              data={this.props.data}
              headers={headers(this.props.screenSize)}
              render={renderFlex(this.props.screenSize, this.editable)}
              isEditable={isEditable(this.props.data, this.editable)}
              editMode="cell"
              editInfo={this.props.editInfo}
              onEditInfoChange={this.props.setEditInfo}
              headerRowHeight={0}
              width={parseInt(this.props.screenSize.width) - 50}
            />
          </div>
        </div>
      </>
    )
  }
}

// const mapStateToProps = state => ({
//   apiTargetInfo: getApiTargetInfo(state),
// })

// const WrappedPerfDisplayGridScreen = props => (
//   <SpinContext.Consumer>
//     {({ spinning, setSpinning }) => (
//       <ErrorContext.Consumer>
//         {({ error, setError }) => (
//           <PerfDisplayGrid
//             spinning={spinning}
//             setSpinning={setSpinning}
//             error={error}
//             setError={setError}
//             {...props}
//           />
//         )}
//       </ErrorContext.Consumer>
//     )}
//   </SpinContext.Consumer>
// )

// export default connect(mapStateToProps)(WrappedPerfDisplayGridScreen)
// export default connect(mapStateToProps)(PerfDisplayGrid)
export default PerfDisplayGrid
